import {
  GET_APP_VARIABLES_REQUEST,
  GET_APP_VARIABLES_SUCCESS,
  GET_APP_VARIABLES_FAILURE,
} from './actionTypes';

export const getAppVariablesRequest = () => ({ type: GET_APP_VARIABLES_REQUEST });
export const getAppVariablesSuccess = (data) => ({ type: GET_APP_VARIABLES_SUCCESS, data });
export const getAppVariablesFailure = (error) => ({ type: GET_APP_VARIABLES_FAILURE, error });
